import store from "@/store";
import { $loaderService } from "@/plugins/ELoaderService";

const redirecionarSeForColaborador = async (to, from, next) => {
  let currentUser = store.getters["Auth/user"];

  if (!currentUser) {
    await $loaderService.loadBasicDataIfNeeded();
  }

  currentUser = store.getters["Auth/user"];
  if (!currentUser) {
    next({ name: "login" });
  } else if (currentUser.roleName === "colaborador") {
    next({ name: "colaboradores.meusPontos" });
  }
};

export default redirecionarSeForColaborador;
